import { render, staticRenderFns } from "./Info.html?vue&type=template&id=9136fb80&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=ts&"
export * from "./Info.vue?vue&type=script&lang=ts&"
import style0 from "./Info.scss?vue&type=style&index=0&id=9136fb80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9136fb80",
  null
  
)

export default component.exports